var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":"登录","width":_vm.isMobile ? '100%' : '900px',"center":"","visible":_vm.visible,"append-to-body":_vm.appendToBody,"before-close":_vm.cancel}},[_c('my-login',{on:{"close":_vm.submit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }